import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { PatchedPostMetricResult } from 'schemas/PostMetricResultSchema'

const EmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<PatchedPostMetricResult>(widgetId)
  const { t } = useTranslation()
  const postMetrics = widgetData?.data?.[0]?.results?.[0]?.data?.metrics

  if (isEmpty(postMetrics)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }
  return children
}

export default EmptyResultGuard
